/**
 * External dependencies
 */
import React, { useState } from 'react';
import { find, map, get } from 'lodash';

/**
 * Internal dependencies
 */
import DropdownLink from 'components/dropdown-link';

/**
 * Style dependencies
 */
import './styles.scss';

const DropdownSelect = ({ options, onChange, selected, ...rest }) => {
	const [selectedOption, setSelectedOption] = useState(selected);

	let _selected = find(options, { value: selectedOption });

	const handleOnChange = (selected) => {
		setSelectedOption(selected);
		onChange && onChange(selected);
	};

	return (
		<DropdownLink
			className='dropdown-select'
			title={get(_selected, 'label', 'Select option')}
			items={map(options, (option) => ({
				key: option.key || option.value,
				onClick: () => handleOnChange(option.value),
				label: option.label,
				active: option.value === selectedOption,
			}))}
			{...rest}
		></DropdownLink>
	);
};

export default DropdownSelect;
